package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_uludi_pub_app_RootModule : Module = module {
	single() { params -> com.uludi.pub.app.root.PubRootComponent(params.get(),authService=get()) } binds(arrayOf(com.arkivanov.decompose.ComponentContext::class,org.koin.core.component.KoinComponent::class))
}
public val com.uludi.pub.app.RootModule.module : org.koin.core.module.Module get() = com_uludi_pub_app_RootModule